import {Directive, ElementRef, EventEmitter, HostListener, Output, inject} from '@angular/core';

@Directive({
  standalone: true,
  selector: '[blurEvent]',
})
export class BlurOnComponentDirective {
  private elementRef = inject(ElementRef);

  @Output() blurEvent = new EventEmitter<Event>();
  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent): void {
    if (event.key === 'Tab') {
      // wait for changing focus on active element
      setTimeout(() => {
        const targetElement = document.activeElement as HTMLElement;
        if (targetElement && !this.elementRef.nativeElement.contains(targetElement)) {
          this.blurEvent.emit();
        }
      });
    }
  }
}
